<template>
    <div class="container-fluid d-flex flex-column">
    <div class="row">
      <h1>Impact Sessions</h1>
    </div>
    <div class="row">
      <div class="col-lg-6" v-for="session in sessions" :key="session.id">
        <div class="session">
          <div class="row mt-2">
            <div class="col-lg-2">
              <img class="img-fluid" :src="session.speaker_image" alt="Session Image" /> <!-- :src="session.speaker_image" src="https://placebeard.it/200/200"-->
            </div>
            <div class="col-lg-10">
              <h2 :class="{ strikethrough: session.percentage === 100 }">{{ session.speaker_name }} ({{ session.room }})</h2>
              <p>{{ formatTime(session.start_at) }} | {{ session.name }}</p>
              <div class="progress">
                <div class="progress-bar" :style="getProgressBarStyle(session.percentage)"></div>
                <div class="vl"></div>
              </div>
              <div class="labels">
                <span>Empty</span>
                <span>Full</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img :src="footerImage" class="footer" alt="Footer"/>
  </div>
</template>

<style scoped src='./CurrentSessionsForEvent.css'></style>

<script>
import axios from 'axios';
import { ref, onMounted, onUnmounted } from 'vue';
import progressBarImage from '@/assets/images/progress_bar.jpg';
import footerImage from '@/assets/images/footer_24.png';

export default {
  data() {
    return {
      progressBarImage,
      footerImage
    };
  },
  setup() {
    const sessions = ref([]);
    const intervalId = ref(null);

    const fetchSessions = async () => {
      try {
        // Get the base URL from environment variable
        const baseUrl = process.env.VUE_APP_API_URL;

        // Get the last part of the current webpage URL
        const urlParts = window.location.pathname.split('/');
        const eventSlug = urlParts[urlParts.length - 1];

        // Construct the full URL with query parameters
        const fullUrl = `${baseUrl}/sessions?time=now&event=${eventSlug}`;

        // Make the API call
        const response = await axios.get(fullUrl);
        sessions.value = response.data.sort((a, b) => new Date(a.start_at) - new Date(b.start_at));
      } catch (error) {
        console.error('Error fetching sessions:', error);
      }
    };

    onMounted(() => {
      fetchSessions();
      intervalId.value = setInterval(fetchSessions, 5000); // Fetch sessions every 5 seconds
    });

    onUnmounted(() => {
      if (intervalId.value) {
        clearInterval(intervalId.value); // Clear the interval when the component is unmounted
      }
    });

    return {
      sessions,
    };
  },
  methods: {
    formatTime(datetime) {
      const date = new Date(datetime);
      let formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true  // Use 12-hour format
      }).format(date);

      // Remove AM/PM from the formatted time
      formattedTime = formattedTime.replace(/AM|PM/gi, '').trim();

      return formattedTime;
    },
    getProgressBarStyle(percentage) {
      return {
        backgroundImage: `url(${this.progressBarImage})`,
        width: percentage + '%',
        backgroundSize: 'cover', // Optionally, you can set how the background image should be sized
      };
    }
  },
};
</script>